<script>
import i18n from '../i18n.js'
import { dateTimeFormatter } from '../tools.js'
import calEventItem from './cal-event-item.vue'
import Button from '@/components/Button'

export default
{
    name: 'cal-events',
    
    data ()
    {
        return {
            i18n
        }
    },
    
    props:
    {
        title: String,
        
        dayEvents:
        {
            type: Object,
            required: true
        },
        
        locale:
        {
            type: String,
            required: true
        },
    
        editable:
        {
            type: Boolean,
            required: true
        }
    },

    render ()
    {
        return (
            <div class='events-wrapper'>
                <div id='content'>
                    <h2 class='date'> {this.dayEventsTitle} </h2>
                    
                    <Button id='add-event-container' text='Ajouter un nouvel événement' type='secondary' icon={require('@/assets/img/plus.svg')}
                        v-show={this.editable} on-click={this.onAddNewEvent} />

                    <div class='cal-events'>
                        <slot>
                        {
                            this.events.map((event, index) =>
                            {
                                return (
                                    <div class='event-item'>
                                        <cal-event-item key={event.id} event={event} locale={this.locale} editable={this.editable}
                                            on-save-changes-clicked={this.onSaveChangesClicked} on-delete-clicked={this.onDeleteClicked} />
                                    </div>
                                )
                            })
                        }
                        </slot>
                    </div>

                    <div v-show={this.events.length == 0 && !this.editable} id='no-events-container'>
                        <inline-svg id='no-events-icon' src={require('@/assets/img/wind.svg')} fill='white' />
                        <p id='no-events-text'>Aucun événement programmé</p>
                    </div>
                </div>
            </div>
        )
    },

    computed:
    {
        dayEventsTitle ()
        {
            if (this.title) return this.title
            if (this.dayEvents.date !== 'all')
            {
                let tempDate
                if (this.dayEvents.events.length !== 0)
                {
                    tempDate = Date.parse(new Date(this.dayEvents.events[0].date))
                    
                    return dateTimeFormatter(tempDate, i18n[this.locale].fullFormat)
                }
                else
                {
                    tempDate = dateTimeFormatter(Date.parse(new Date(this.dayEvents.date)), i18n[this.locale].fullFormat)
                    
                    return `${tempDate} ${i18n[this.locale].notHaveEvents}`
                }
            }
            else
            {
                return i18n[this.locale].dayEventsTitle
            }
        },

        events ()
        {
            return this.dayEvents.events
        }
    },

    methods:
    {
        dateTimeFormatter,

        onSaveChangesClicked (event, button, e)
        {
            this.$emit('save-changes-clicked', event, button, e)
        },

        onAddNewEvent ()
        {
            this.$emit('add-new-event')
        },

        onDeleteClicked (event)
        {
            this.$emit('delete-clicked', event)
        }
    },

    components:
    {
        calEventItem,
        Button
    }
}
</script>

<style lang='less' scoped>
@import '~@/styles/main.less';

.events-wrapper
{
    #content
    {
        max-width: 600px;
        width: -webkit-fill-available;
    }
}

#no-events-container
{
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 5vh;

    .OnDesktop({
        margin-top: 20%;
        margin-bottom: 20%;
    });

    #no-events-icon
    {
        fill: var(--theme-accent-color-light-30-percent);
        width: 30%;
        height: auto;

        .OnTablet({ width: 20%;});
    }

    #no-events-text
    {
        color: var(--theme-accent-color-light-30-percent);
        margin-top: 30px;

        .OnDesktop({
            margin-top: 60px;
            font-size: 2vh;
        });
    }
}

#add-event-container
{
    width: -webkit-fill-available;
    margin: 6px;

}
</style>


// WEBPACK FOOTER //
// src/components/vue-calendar/components/cal-events.vue